module.exports = __webpack_public_path__ + "client/styles/fonts/Roboto-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/styles/fonts/Roboto-Bold.ttf
// module id = 1481
// module chunks = 0